var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"counter-wrapp\">  <div class=\"count\" ng-repeat=\"num in count track by $index\"> {{num}} </div> </div>";
ngModule.run(["$templateCache",function(c){c.put("counter/templates/counter.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/counter/templates/counter.html
 ** module id = 557
 ** module chunks = 1
 **/